import React from "react";
import Box from "@mui/material/Box";
import Fade from "react-reveal/Fade";
import { useTranslation } from "react-i18next";

const Testimonial1 = () => {
  const { t, i18n } = useTranslation();
  return (
    <Box
      sx={{
        width: 1,

        display: "flex",
        justifyContent: "center",
      }}
    >
      <Fade delay={400}>
        <Box>
          {t("Wipe it all clean!")}
          <Box className="normal" sx={{ fontSize: "14px", pt: 1 }}>
            <div
              dangerouslySetInnerHTML={{
                __html: t(
                  "The wipes cleans up well and doesn't leave water mark after wiping.<br />No strong odor, didn't dry out hands after using."
                ),
              }}
            />
          </Box>
          <Box sx={{ fontSize: "14px", fontWeight: 100, pt: 1, color: "gray" }}>
            Ky***** {t("Uijeongbu, South Korea")}
          </Box>
        </Box>
      </Fade>
    </Box>
  );
};

export default Testimonial1;
